import { render, staticRenderFns } from "./PriceHistogramFilter.vue?vue&type=template&id=2566ed2e&scoped=true&"
import script from "./PriceHistogramFilter.vue?vue&type=script&lang=js&"
export * from "./PriceHistogramFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceHistogramFilter.vue?vue&type=style&index=0&id=2566ed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566ed2e",
  null
  
)

export default component.exports